export var CampaignConditionType;
(function (CampaignConditionType) {
    CampaignConditionType["EQUALS"] = "EQUALS";
    CampaignConditionType["NOT_EQUALS"] = "NOT_EQUALS";
    CampaignConditionType["GREATER_THAN"] = "GREATER_THAN";
    CampaignConditionType["LESS_THAN"] = "LESS_THAN";
    CampaignConditionType["CONTAINS"] = "CONTAINS";
    CampaignConditionType["IS_PART_OF"] = "IS_PART_OF";
})(CampaignConditionType || (CampaignConditionType = {}));
//# sourceMappingURL=campaignConditionType.enum.js.map